// extracted by mini-css-extract-plugin
export default {"cardsContainer":"Cards_cardsContainer__nnaBy"};